<div #wrapper class="weight-qty-wrapper">
    <app-modal-header [text]="externalMeal.title" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container *ngIf="externalMealsComponent && externalMealsComponent.mealsComponent">
        <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
            <div class="attributes">
                <div class="attribute">
                    <p class="attribute-title">
                        {{ 'hranene' | localise }}:
                    </p>

                    <ul>
                        <li *ngFor="let meal of externalMealsComponent.mealsComponent.orderedUserDailyMeals">
                            <div class="form-group">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input
                                                class="form-check-input"
                                                [checked]="selectedMeal && selectedMeal.id === meal.id"
                                                name="selected-meal" type="radio" (click)="markAttrOption(meal.id, meal)" value="">
                                        {{ meal.title }}
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
            <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
            <button type="button" class="btn btn-success" (click)="save()">{{ 'save' | localise }}</button>
        </div>
    </ng-container>
</div>
